import '../scss/main.scss'

// just a test
export const multiply = (n1, n2) => n1 * n2



// WEBPACK FOOTER //
// ./js/main.js